import React from "react";
import FormattedNumber from "@/shared/components/FormattedNumber";
import { useChainContext } from "@/containers/context/context";

function InfoTokenView({ infoToken, onClose, getTypeLabel }) {
  const { globalTokensLogo } = useChainContext();

  if (!infoToken) return null;

  const matchTokenUrl = (tokenName) => {
    if (!tokenName) return "";
    const directMatch = globalTokensLogo?.find(
      (token) => token.symbol?.toUpperCase() === tokenName.trim().toUpperCase()
    );
    if (directMatch) {
      return directMatch.url;
    }
    let normalizedTokenName = tokenName.trim().toUpperCase();
    normalizedTokenName = normalizedTokenName.replace(/\(.*?\)/g, "").trim();
    normalizedTokenName = normalizedTokenName.replace(/[^A-Z0-9]/g, "");
  
    const matchedToken = globalTokensLogo?.find(
      (token) => token.symbol?.toUpperCase().replace(/[^A-Z0-9]/g, "") === normalizedTokenName
    );
    if (!matchedToken) {
      const fallbackToken = globalTokensLogo?.find((token) =>
        token.url?.toLowerCase().includes(normalizedTokenName.toLowerCase())
      );
      return fallbackToken?.url || "";
    }
    return matchedToken.url;
  };

  const tokenLogoUrl = matchTokenUrl(infoToken.symbol);

  const getExplorerUrl = (contractAddress, chainId) => {
    if (!contractAddress) return "#";
    
    // Map chain IDs to explorer URLs
    const explorerMap = {
      1: `https://etherscan.io/address/${contractAddress}`, // Ethereum Mainnet
      56: `https://bscscan.com/address/${contractAddress}`, // BSC Mainnet
      137: `https://polygonscan.com/address/${contractAddress}`, // Polygon Mainnet
      11155111: `https://sepolia.etherscan.io/address/${contractAddress}`, // Ethereum Sepolia
      97: `https://testnet.bscscan.com/address/${contractAddress}`, // BSC Testnet
      80001: `https://mumbai.polygonscan.com/address/${contractAddress}`, // Polygon Mumbai
    };
    
    return explorerMap[chainId] || `https://etherscan.io/address/${contractAddress}`;
  };

  return (
    <div
      style={{
        marginTop: "16px",
        padding: "16px",
        border: "1px solid #1f2937",
        borderRadius: "12px",
        background: "rgba(15,23,42,0.6)",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: "18px", fontWeight: 600 }}>{infoToken.symbol}</div>
          <div style={{ opacity: 0.7 }}>{getTypeLabel(infoToken.type)}</div>
        </div>
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            // background: "#1f2937",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          {tokenLogoUrl ? (
            <img
              src={tokenLogoUrl}
              alt={infoToken.symbol}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          ) : null}
        </div>
      </div>
      <div style={{ marginTop: "12px", fontSize: "14px" }}>
        Balance: $<FormattedNumber value={infoToken.balance || 0} maxDecimals={2} />
      </div>
      {infoToken.contract_address && (
        <>
          <div style={{ marginTop: "8px", fontSize: "12px" }}>
            Contract: {infoToken.contract_address.length > 10 
              ? `${infoToken.contract_address.slice(0, 6)}...${infoToken.contract_address.slice(-4)}`
              : infoToken.contract_address}
          </div>
          <div style={{ marginTop: "4px", fontSize: "12px" }}>
            <a 
              href={getExplorerUrl(infoToken.contract_address, infoToken.chain_id)}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#5ce9ff", textDecoration: "underline" }}
            >
              Explorer link
            </a>
          </div>
        </>
      )}
      <button
        style={{
          marginTop: "12px",
          padding: "6px 10px",
          borderRadius: "6px",
          background: "#00f7d2",
          border: "none",
          cursor: "pointer",
          color: "#001018",
          fontWeight: 600,
        }}
        onClick={onClose}
      >
        Close Info
      </button>
    </div>
  );
}

export default InfoTokenView;

